var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feed feed__widget" }, [
    _c("div", { staticClass: "trending-title" }, [
      _c("span", { staticClass: "pointer", on: { click: _vm.toggleList } }, [
        _vm._v("Trending Profiles\n            ")
      ]),
      _vm._v(" "),
      _c("span", [
        _c("img", {
          staticClass: "refresh-follow",
          attrs: { src: require("../../assets/imgs/exchange/refresh.png") },
          on: { click: _vm.updateFrequenciesList }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isHide,
            expression: "!isHide"
          }
        ],
        staticClass: "feed__trendingList"
      },
      [
        _c(
          "a",
          { staticClass: "btn m-b-30", attrs: { href: "/trending_feeds" } },
          [_vm._v(" Manage Follows ")]
        ),
        _vm._v(" "),
        _vm._l(_vm.trendingFrequencies, function(item) {
          return _c(
            "div",
            { key: item.user_id, staticClass: "feed__line clearfix" },
            [
              _c("a", {
                staticClass: "ava__s",
                style: { backgroundImage: "url(" + item.avatar + ")" },
                attrs: { href: "/users/" + item.user_id + "/other_profile" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "feed__line__content" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "/users/" + item.user_id + "/other_profile" }
                  },
                  [
                    _c("span", { staticClass: "text__bold color__gray" }, [
                      _vm._v(_vm._s(item.name))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "fs__12 color__gray__secondary" }, [
                  _c("span", { staticClass: "text__bold" }, [
                    _vm._v(_vm._s(item.followers))
                  ]),
                  _vm._v(" Followers\n                ")
                ])
              ]),
              _vm._v(" "),
              _c("AddFriendBtn", {
                staticClass: "p-l-1r",
                attrs: {
                  short: true,
                  user: Object.assign({}, { id: item.user_id }, item)
                },
                on: {
                  is_friend: function($event) {
                    item.is_friend = $event
                  },
                  friend_status: function($event) {
                    item.friend_status = $event
                  }
                }
              }),
              _vm._v(" "),
              item.is_following
                ? _c("div", { staticClass: "p-l-1r" }, [
                    _c(
                      "button",
                      {
                        staticClass: "feed__icon",
                        on: {
                          click: function($event) {
                            return _vm.follow("unfollow", item.user_id)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@assets/imgs/exchange/follow_confirmed.png")
                          }
                        })
                      ]
                    )
                  ])
                : _c("div", { staticClass: "p-l-1r" }, [
                    _c(
                      "button",
                      {
                        staticClass: "feed__icon",
                        on: {
                          click: function($event) {
                            return _vm.follow("follow", item.user_id)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@assets/imgs/exchange/follow.png")
                          }
                        })
                      ]
                    )
                  ])
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }